export default "__VITE_ASSET__DyUIdfnS__"